import { serviceRoles } from "config/access";
import { GIT_REPOS } from "constants/routes";
import { checkAccess } from "helpers/auth";
import Page from "./container/GitReposPage";

export default function getSettingsRoute(userAuth) {
  const { account } = serviceRoles;
  const requireAuth = {
    [account.name]: [account.roles.superadmin],
  };
  return {
    requireAuth,
    onEnter: () => checkAccess(requireAuth, userAuth),
    path: GIT_REPOS,
    withSidebar: true,
    withAppBar: true,
    component: Page,
  };
}
